import AddConsultingCaseRequestModelBase from '../_generated/modelBases/add-consulting-case-request-model-base';

export default class AddConsultingCaseRequestModel extends AddConsultingCaseRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
